import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary,IconButton, Tooltip } from "@mui/material";
import React, {useState } from "react";
import MergeData from '../../config/MergeCardDetailsData.json'
import LaunchIcon from '@mui/icons-material/Launch';
import InboxReferenceLink from '../../config/ProfileDetailsData.json'
import CONFIG from "../../config";
import ProfileIcon from '../shared/ProfileIcon';


const MergeDetails = (props) => {
  const [details] = useState(props.details);
  const [expanded, setExpanded] = useState(true);
  const [mergeData] = useState(MergeData.field_Map)

  const handleAccordian = (key) => (event, isExpanded) => {
    setExpanded({
      ...expanded,
      [key]: !expanded[key],
    });
  };

  const getValueFromPath = (obj, path) => {
    const pathParts = path.split('.'); // Split the path into parts
    let value = obj; // Start with the base object
  
    pathParts.forEach(part => {
      // If the part has array access (e.g., [0])
      if (part.includes('[')) {
        const arrayIndex = part.match(/\[(\d+)\]/); // Match the index in the array
        if (arrayIndex) {
          const index = parseInt(arrayIndex[1], 10); // Get the index number
          value = value[part.split('[')[0]] ? value[part.split('[')[0]] : null; // Get the array
          value = value != null ? value[index]: null; // Access the specific index
        }
      } else {
        value = value != null ? value[part]: null; // Regular object property access
      }
    });
  
    return value;
  };

  const handleLaunch = (event, link) => {
    event?.stopPropagation()
    window.open(link)
   }

  return (
    <>
      {details?.map((res, key)=>(
       
   
        <Accordion
          expanded={expanded[res._source._id] || false}
          key={Math.random()}
          style={{
            backgroundColor: "#f8f9f9",
            marginTop: 3,
            marginRight: 8,
            marginLeft: 8,
          }}
        >
           
          <AccordionSummary
            style={{ fontSize: "small" }}
            onClick={handleAccordian(res._source._id)}
            key={Math.random()}            
            expandIcon={ <Tooltip disableFocusListener title={expanded[res._source._id]  ? "Close" : "Open"}>
            <ExpandMore />
            </Tooltip>}>
             <ProfileIcon
              type={res.type}
              sx={{width: '35px', height: '35px'}}
          />
           <h6 style={{marginBlock: 'auto', paddingLeft:'10px', paddingRight: '10px'}}>
           {res._source.label}     
            </h6>                    
          </AccordionSummary>
          <AccordionDetails
            className="_wg-dynamic-text"
            style={{ fontSize: "small", backgroundColor: "#ffffff" }}
          >{
            mergeData.map((data, index)=>{
                const value = getValueFromPath(res, data.from_Key)
                return (
                  <>
                    
                    { value != null && 
                     <React.Fragment key={Math.random()}>                     
                     <span  className='text-muted'>{data.label_Name}: </span>
                     <span className="_wg-exclude">{value} </span>
                     {(data.label_Name == 'HCPReferenceId' || data.label_Name == 'HCOReferenceId') &&
                      <Tooltip disableFocusListener title={"View in EPH"}>
                        <IconButton size="small" aria-label="link " color="primary" onClick={(e)=> handleLaunch(e, InboxReferenceLink.INBOX_REFERENCE_LINK[0][CONFIG.env]+res._id)}>
                          <LaunchIcon fontSize={'5px'}/>
                        </IconButton>
                      </Tooltip>
                    }
                     <br/>  
                    </React.Fragment>
                    }
                    </>
                  );
            }

            )
          }
          </AccordionDetails>
        </Accordion>
       
      ))}
    </>
  );
};

export default MergeDetails;
